export const SITES_TEMPLATE_BASE = {
    ECOM: "demo-ecommerce-base",
};

export const PAGE_TEMPLATES = {
    STANDARD: "demo-ecommerce-base:pages/standard",
    HOME: "demo-ecommerce-base:pages/home",
    PRODUCT_OVERVIEW: "demo-ecommerce-base:pages/productOverview",
    PRODUCT_DETAIL: "demo-ecommerce-base:pages/productDetail",
};

export const COMPONENT_TEMPLATES = {
    HERO: "demo-ecommerce-base:components/hero/hero",
    HERO_SLIDE: "demo-ecommerce-base:components/hero/heroSlide",
    HEADLINE: "demo-ecommerce-base:components/headline",
    IMAGE: "demo-ecommerce-base:components/image",
    GRID: "demo-ecommerce-base:components/grid",
    HTML: "demo-ecommerce-base:components/html",
    CARD_TEASER: "demo-ecommerce-base:components/cardTeaser",
    FORM: "demo-ecommerce-base:components/form",
};
